"use strict";
exports.__esModule = true;
exports.PromotionTypes = void 0;
var PromotionTypes;
(function (PromotionTypes) {
    PromotionTypes["HeaderBanner"] = "header-banner";
    PromotionTypes["SearchCard"] = "search-card";
})(PromotionTypes = exports.PromotionTypes || (exports.PromotionTypes = {}));
